import React, {useState, useRef, useLayoutEffect} from "react";
import styled, {css} from "styled-components";
import PropTypes from "prop-types";

// Style
import {slideLeft} from "../../style/components/animations";
import {Text} from "../../style/components/general";

const Marquee = ({text, bold = true}) => {
  const textRef = useRef(null);

  const [overflow, setOverflow] = useState(false);

  useLayoutEffect(() => {
    const {current} = textRef;

    if (!current) return undefined;

    const checkOverflow = () => setOverflow(current.scrollWidth > current.clientWidth);

    checkOverflow();

    if (typeof ResizeObserver === "undefined") return undefined;

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(current);
    return () => observer.disconnect();
  }, [text]);

  return (
    <Wrapper shouldAnimate={overflow}>
      <MarqueeAnimation bold={bold}>
        {text}&nbsp;
        {text}
      </MarqueeAnimation>
      <Original ref={textRef} bold={bold}>
        {text}
      </Original>
    </Wrapper>
  );
};

Marquee.propTypes = {
  text: PropTypes.node.isRequired,
  bold: PropTypes.bool
};

// Style Overrides
const MarqueeAnimation = styled(Text)`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  white-space: nowrap;
  ${({bold}) =>
    bold &&
    css`
      font-weight: bold;
    `}
`;

const Original = styled(Text)`
  display: block;
  width: 100%;
  word-wrap: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${({bold}) =>
    bold &&
    css`
      font-weight: bold;
    `}
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  &:hover {
    ${MarqueeAnimation} {
      opacity: ${({shouldAnimate}) => (shouldAnimate ? 1 : 0)};
      animation: ${slideLeft} linear 10s infinite;
    }

    ${Original} {
      opacity: ${({shouldAnimate}) => (shouldAnimate ? 0 : 1)};
    }
  }
`;

export default Marquee;
